<template>
  <div
      v-if="videoModalOpen"
      class="remote_section"
      :class="noteArrow ? '' : 'open'"
  >
    <div class="remote_container left" :class="noteArrow ? '' : 'hidden_remote_left'">
      <RemoteHeader
          :deviceSetAlertProps="deviceSetAlert"
          :patientTotalInfoProps="patientTotalInfo"
          :selectedScheduleProps="selectedSchedule"
          :progressTimeProps="progressTime"
          :meetingStatusProps="meetingStatus"
          @openSetModal="openSetModal"
          @makeACall="makeACall"
          @endTheCall="endTheCall"
      />
      <DeviceSetModal
          v-if="deviceSetModal"
          :windowRefProps="windowRef"
          :browserAlertProps="browserAlert"
          :deviceListProps="deviceList"
          :preSetDeviceIdProps="preSetDeviceId"
          :isIpadProps="deviceBrowser.speakerNonCheck"
          :yourCameraLeftRight="yourCameraLeftRight"
          :yourElement="yourElement"
          @closeSetModal="closeSetModal"
          @completeSetting="completeSetting"
          @onTileClick="handleTileClick"
      />
      <MonitorArea
          :meetingStatusProps="meetingStatus"
          :progressTimeProps="progressTime"
          ref="monitor"
      />
      <MyMonitorArea
          :audioVideoProps="audioVideo"
          :cameraProps="camera"
          :deviceListProps="deviceList"
          :realTimeAttendeesProps="realTimeAttendees"
          :tileCountProps="tileCount"
          @clickVideoSwitch="clickVideoSwitch"
          ref="myMonitor"
      />
      <DeviceControlNav
          :arrowProps="arrow"
          :muteProps="mute"
          :cameraProps="camera"
          :volumeProps="volume"
          @clickArrowBtn="clickArrowBtn"
          @clickMicBtn="clickMicBtn"
          @clickVideoBtn="clickVideoBtn"
          @clickVolumeBtn="clickVolumeBtn"
          @clickChange="handleTileClick"
      />
    </div>
    <OnlineVisitNote
        :patientTotalInfoProps="patientTotalInfo"
        :selectedScheduleProps="selectedSchedule"
        :windowRefProps="windowRef"
        :noteArrow="noteArrow"
        @onClickNoteArrowBtn="handleClickNoteArrowBtn"
    />
    <YesOrNoModal/>
  </div>
</template>
<script>
import remoteViewMethods from './remoteViewMethods';
import OnlineVisitNote from '@/components/body/videoCall/onlineVisitNote';
import MonitorArea from '@/components/body/videoCall/monitorArea';
import MyMonitorArea from '@/components/body/videoCall/myMonitorArea';
import DeviceControlNav from '@/components/body/videoCall/deviceControlNav';
import DeviceSetModal from '@/components/body/videoCall/deviceSetModal';
import RemoteHeader from '@/components/body/videoCall/remoteHeader';
// import MobileLogForDev from '@/components/body/videoCall/mobileLogForDev';
import YesOrNoModal from '@/components/body/videoCall/yesOrNo';

import _API from '../api';
import {copyStyles} from '@/static';
import {mapGetters, mapActions} from "vuex";
import * as pako from 'pako';

// Amazon Chime SDK를 안전하게 로드하기 위한 변수들
let ConsoleLogger, DefaultDeviceController, DefaultMeetingSession, LogLevel, MeetingSessionConfiguration;
let chimeSDKLoaded = false;

// pako를 전역에서 사용할 수 있도록 설정
if (typeof window !== 'undefined') {
  window.pako = pako;
  
  // exports와 module 전역 객체 정의 (Amazon Chime SDK용)
  if (!window.exports) {
    window.exports = {};
  }
  if (!window.module) {
    window.module = { exports: window.exports };
  }
  if (!window.global) {
    window.global = window;
  }
}

// Amazon Chime SDK 비동기 로드 함수
async function loadChimeSDK() {
  if (chimeSDKLoaded) return true;
  
  try {
    console.log('[RemoteView] Amazon Chime SDK 로드 시작');
    
    // 동적 import로 Amazon Chime SDK 로드
    const chimeModule = await import('amazon-chime-sdk-js');
    
    ConsoleLogger = chimeModule.ConsoleLogger;
    DefaultDeviceController = chimeModule.DefaultDeviceController;
    DefaultMeetingSession = chimeModule.DefaultMeetingSession;
    LogLevel = chimeModule.LogLevel;
    MeetingSessionConfiguration = chimeModule.MeetingSessionConfiguration;
    
    chimeSDKLoaded = true;
    console.log('[RemoteView] Amazon Chime SDK 로드 성공');
    return true;
    
  } catch (error) {
    console.error('[RemoteView] Amazon Chime SDK 로드 실패:', error);
    
    // Fallback: 기본 구현체 생성
    LogLevel = { 
      INFO: 'INFO', 
      WARN: 'WARN', 
      ERROR: 'ERROR',
      DEBUG: 'DEBUG',
      OFF: 'OFF'
    };
    
    ConsoleLogger = class FallbackConsoleLogger {
      constructor(name, level) {
        this.name = name;
        this.level = level;
      }
      info(...args) { console.log(`[${this.name}]`, ...args); }
      warn(...args) { console.warn(`[${this.name}]`, ...args); }
      error(...args) { console.error(`[${this.name}]`, ...args); }
      debug(...args) { console.debug(`[${this.name}]`, ...args); }
    };
    
    DefaultDeviceController = class FallbackDeviceController {
      constructor(logger) {
        this.logger = logger;
      }
      async listVideoInputDevices() { 
        console.warn('[FallbackDeviceController] listVideoInputDevices 호출됨');
        return []; 
      }
      async listAudioInputDevices() { 
        console.warn('[FallbackDeviceController] listAudioInputDevices 호출됨');
        return []; 
      }
      async listAudioOutputDevices() { 
        console.warn('[FallbackDeviceController] listAudioOutputDevices 호출됨');
        return []; 
      }
    };
    
    chimeSDKLoaded = false;
    console.warn('[RemoteView] Fallback 모드로 동작합니다');
    return false;
  }
}

export default {
  name: 'remoteView',
  components: {
    OnlineVisitNote,
    MonitorArea,
    MyMonitorArea,
    DeviceControlNav,
    DeviceSetModal,
    RemoteHeader,
    // MobileLogForDev,
    YesOrNoModal
  },
  data() {
    return {
      //for logging.
      mode: process.env.NODE_ENV,
      devLog: [],
      meetingEvents: [],
      API_ENDPOINT_URL: 'https://rzbct3ojtf.execute-api.ap-northeast-2.amazonaws.com/prod/meetingevents',

      // 모달 open/close, 환경 관련된 값
      deviceBrowser: this.getDeviceBrowser(),

      windowRef: null,

      // 통화와 관련된 값
      meeting: '', // 서버로부터 받아온 미팅 정보
      attendeeId: '',
      audioVideo: '', // 차임에서 만든 오디오 비디오 객체
      realTimeAttendees: [], // 실시간 참석자의 attendee id
      tileCount: 0, // 연결된 타일의 갯수,
      myTileId: 0,
      yourTileId: 0,
      stopCalling: true, // 의사가 전화 중지 버튼을 클릭한 경우 true/ 아닌 경우 false
      startDatetime: '', // 쌍방 통화 시작 날짜 시간
      progressTime: 0, // 통화 시간(초)

      // 상태에 따른 화면에 메세지 노출 여부
      meetingStatus: 'waiting',

      // 화면 엘레멘트 display on/off
      // yourAudioElement: false, // 차임이 오디오를 붙였을때 true, display 됨

      // 버튼과 관련된 값
      mute: false, // true 면 음소거 상태, false 면 음소거 off
      volume: true, // true 면 스피커 on, false 면 스피커 off
      camera: true, // true 면 내 카메라 on, false 면 내 카메라 off
      switchVideo: true, // true 면 내 카메라가 작은 화면, false 면 상대 카메라가 작은 화면

      // 모달 내 환자 정보
      selectedSchedule: '',
      patientName: '',
      seqMedicalRelation: 0,
      patientTotalInfo: '',

      // 디바이스와 관련된 값
      logger: {},
      deviceController: {},
      deviceSetAlert: true, // 디바이스가 없을 경우 true
      deviceSetModal: false, // 디바이스 세팅 창 on/off
      preSetDeviceId: JSON.parse(localStorage.getItem('preSetDeviceId')),
      deviceList: {cameraList: [], micList: [], speakerList: []},
      browserAlert: '',
      deviceResetCnt: 0,

      yourElement: null,
      yourCameraLeftRight: false,

      checkClose: false,

      arrow: true,
      noteArrow: true,
    }
  },
  created() {
    console.log('[RemoteView] created - 컴포넌트 생성됨');
    console.log('[RemoteView] created - 영상통화 상태:', this.$store.getters.getVideoCallOpen);
    console.log('[RemoteView] created - 디바이스 브라우저:', this.deviceBrowser);
    console.log('[RemoteView] created - App.vue에서 마운트됨');
    
    // 모바일의 경우
    if (this.deviceBrowser.notNewWindow) {
      console.log('[RemoteView] created - 모바일 환경 처리');
      // 통화 화면에서, 뒤로가기 후 다시 앞으로 가기를 누할 경우, 스케쥴 정보가 없다면, 통화 화면으로의 진입을 막는다.
      if (this.$store.getters.getVideoCallSelectedSchedule === '') {
        console.log('[RemoteView] created - 스케줄 정보 없음, 뒤로가기');
        this.$router.go(-1);
        return
      }
      this.windowRef = this;
      this.openPortal();
      this.setPortalEvent();
    } else {
      console.log('[RemoteView] created - PC 환경, App.vue에서 전역으로 마운트됨');
    }
  },
  beforeMount() {
    // 모바일의 경우 로그 보기 위한 코드
    if (this.deviceBrowser.notNewWindow) {
      console.__proto__.dev = (msg, value) => {
        this.devLog.push(msg);
        this.devLog.push(value);

        if (process.env.NODE_ENV === "development")
          console.log('[h robotics]', msg, value);
      }
    }
  },
  mounted() {
    console.log('[RemoteView] mounted 시작');
    console.log('[RemoteView] mounted - 디바이스 브라우저:', this.deviceBrowser);
    console.log('[RemoteView] mounted - 영상통화 상태:', this.$store.getters.getVideoCallOpen);
    console.log('[RemoteView] mounted - notNewWindow:', this.deviceBrowser.notNewWindow);
    
    // PC 환경에서 영상통화 상태가 true라면 새 창 열기
    if (!this.deviceBrowser.notNewWindow && this.$store.getters.getVideoCallOpen) {
      console.log('[RemoteView] PC 환경에서 영상통화 상태가 true - 새 창 열기 시도');
      this.$nextTick(() => {
        console.log('[RemoteView] nextTick에서 새 창 관련 함수 호출');
        try {
          this.openPortal();
          console.log('[RemoteView] openPortal 완료');
          this.makeNewWindowPortal();
          console.log('[RemoteView] makeNewWindowPortal 완료');
          this.setPortalEvent();
          console.log('[RemoteView] setPortalEvent 완료');
        } catch (error) {
          console.error('[RemoteView] 새 창 열기 중 오류:', error);
        }
      });
    } else {
      console.log('[RemoteView] 새 창 열기 조건 불만족:', {
        notNewWindow: this.deviceBrowser.notNewWindow,
        videoCallOpen: this.$store.getters.getVideoCallOpen
      });
    }
    
    this.intervalId = setInterval(() => {
      if (localStorage.getItem('refreshToken') === null) {
        this.handleClose();
        this.initAllValues();
    try {
      if (!window.__justSavedRefreshToken) {
        localStorage.setItem('refreshToken', '');
      } else {
        console.debug('[REMOTE_VIEW] skipped clearing refreshToken due to recent save');
      }
    } catch (e) { localStorage.setItem('refreshToken', ''); }
      }
    }, 1000)
  },
  beforeDestroy() {
    // 모바일의 경우만
    this.closePortal();
    clearInterval(this.intervalId)
  },
  watch: {
    // PC 버전의 새창을 여는 역할
    checkOpen: {
      immediate: true,
      handler(newVal, oldVal) {
        console.log('[checkOpen] watcher 실행:', {
          newVal,
          oldVal,
          deviceBrowser: this.deviceBrowser,
          notNewWindow: this.deviceBrowser.notNewWindow
        });
        
        if (newVal) {
          console.log('[checkOpen] 영상통화 모달 열기 시작');
          this.openPortal();
          
          if (!this.deviceBrowser.notNewWindow) {
            console.log('[checkOpen] PC 환경 - makeNewWindowPortal 호출');
            this.makeNewWindowPortal();
          } else {
            console.log('[checkOpen] 모바일/터치 환경 - 새 창 열기 생략');
          }
          
          this.setPortalEvent();
          console.log('[checkOpen] 영상통화 모달 열기 완료');
        } else {
          console.log('[checkOpen] 영상통화 모달 닫기');
        }
      }
    },
    // 사용가능한 디바이스가 없는 경우 경고창을 띄우는 역할
    deviceList: {
      deep: true,
      handler(newVal) {
        if (newVal.cameraList.length === 0 || newVal.micList.length === 0 || newVal.speakerList.length === 0) {
          this.deviceSetAlert = true;

          if (newVal.cameraList.length === 0) {
            this.camera = false;
          }

          // ipad 의 경우, speaker 를 선택할 수 없어 예외 처리
          if (newVal.speakerList.length === 0 && this.deviceBrowser.speakerNonCheck) {
            this.deviceSetAlert = false;
          }
        } else {
          this.deviceSetAlert = false;
        }
      }
    },
    realTimeAttendees: {
      deep: true,
      handler(newVal) {
        console.dev('[watch] [realTimeAttendees] 실시간 참석자 배열 : ', newVal);

        if (this.realTimeAttendees.length === 2) {
          if (this.startDatetime === '') {
            this.startDatetime = this.moment.tz(undefined, this._TIME_ZONE).format();
          }
          this.countFunction = setInterval(() => {
            console.dev('[watch] [countFunction] 통화시간 카운트 시작합니다. ');
            this.progressTime = this.progressTime + 1
          }, 1000);

          if (this.yourTileId === 0) { // 통화는 시작했지만, 타일은 붙지 않은 상태
            console.dev('[watch] [this.yourTileId === 0] 통화는 시작했지만, 환자의 타일은 붙지 않은 상태입니다.');
            this.changeMeetingStatus('off');
          }
        } else {
          this.stopCounting(this.countFunction);
        }
      }
    },
    // 통화 중 사용자가 장치 모달을 통해 장치를 변경했을 경우
    preSetDeviceId: {
      deep: true,
      handler(newVal, oldVal) {
        if (this.audioVideo) {
          try {
            if (newVal?.audioInputDeviceId !== oldVal?.audioInputDeviceId)
              newVal?.audioInputDeviceId && this.audioVideo.chooseAudioInputDevice(newVal?.audioInputDeviceId)

            if (newVal?.audioOutputDeviceId !== oldVal?.audioOutputDeviceId)
              newVal?.audioOutputDeviceId && this.audioVideo.chooseAudioOutputDevice(newVal?.audioOutputDeviceId)

            if (newVal?.videoInputDeviceId !== oldVal?.videoInputDeviceId) {
              newVal?.videoInputDeviceId && this.audioVideo.chooseVideoInputDevice(newVal?.videoInputDeviceId)
                  .catch(async () => {
                    window.setTimeout(() => {
                      this.camera = false;
                    }, 0);

                    window.setTimeout(() => {
                      this.deviceResetCnt = this.deviceResetCnt + 1;
                      this.camera = true;
                    }, 1000);
                  })
            }
          } catch (err) {
            this.windowRef.alert(this.$t('alert.check_device_available'));
            return false
          }
        }
      }
    },
    mute() {
      console.dev('[watch] 뮤트 on/off 상태 boolean : ', this.mute);
      if (this.audioVideo) {
        if (this.mute) {
          this.audioVideo.realtimeMuteLocalAudio();
        } else {
          this.audioVideo.realtimeUnmuteLocalAudio();
        }
      }
    },
    volume() {
      console.dev('[watch] 볼륨 on/off 상태 boolean : ', this.volume);
      if (this.audioVideo) {
        const yourAudio = document.getElementById('yourAudio');

        if (this.volume) {
          this.audioVideo.bindAudioElement(yourAudio);
        } else {
          this.audioVideo.unbindAudioElement(yourAudio);
        }
      }
    },
    async camera() {
      console.dev(`[watch] 카메라 on/off 상태 boolean : ${this.camera}`);
      if (this.audioVideo) {
        if (this.camera) {// 카메라 켜자
          await this.audioVideo.chooseVideoInputDevice(this.preSetDeviceId?.videoInputDeviceId ? this.preSetDeviceId.videoInputDeviceId : this.deviceList.cameraList[0].deviceId || null)
              .catch(() => {
                if (this.deviceResetCnt <= 10) {
                  window.setTimeout(() => {
                    this.camera = false;
                  }, 0);

                  window.setTimeout(() => {
                    this.deviceResetCnt = this.deviceResetCnt + 1;
                    this.camera = true;
                  }, 1000);
                } else {
                  this.deviceResetCnt = 0;
                  this.camera = false;
                  this.windowRef.alert(this.$t('alert.check_device_available'));
                }
              });
          this.audioVideo.startLocalVideoTile();
        } else {// 카메라 끄자
          this.audioVideo.chooseVideoInputDevice(null);
          this.audioVideo.unbindVideoElement(this.myTileId);
          this.audioVideo.stopLocalVideoTile();
          this.audioVideo.removeLocalVideoTile();
        }
      }
    },
    async switchVideo() {
      if (this.audioVideo) {
        console.dev('[switchVideo] 비디오의 위치를 변경한다. myTileId : ', this.myTileId);
        await this.audioVideo.unbindVideoElement(this.yourTileId);
        await this.audioVideo.unbindVideoElement(this.myTileId);
        this.$refs.monitor.$refs.yourVideo.srcObject = null;
        this.$refs.myMonitor.$refs.myVideo.srcObject = null;
      }
    },
  },
  computed: {
    checkOpen() {
      const isOpen = this.$store.getters.getVideoCallOpen;
      console.log('[checkOpen] computed 호출:', isOpen);
      return isOpen;
    },
    videoModalOpen() {
      const isOpen = this.$store.getters.getVideoCallOpen;
      console.log('[videoModalOpen] computed 실행:', {
        isOpen,
        deviceBrowser: this.deviceBrowser,
        notNewWindow: this.deviceBrowser?.notNewWindow
      });
      return isOpen;
    }
  },
  methods: {
    ...remoteViewMethods,
    ...mapGetters(['getDeviceBrowser']),
    ...mapActions(['toggleRemoteModal']),
    handleClickNoteArrowBtn(boolean) {
      this.noteArrow = boolean;
    },
    handelEvent() {
      localStorage.setItem('time', this.moment().format());
    },
    handleUnload() {
      this.handleClose();
    },
    /**
     * 환자정보, 장치 등을 세팅하고 화면을 연다.
     */
    openPortal() {
      this.getSelectedScheduleFromVuex();
      this.setPatientInfo();
      this.$store.dispatch('toggleRemoteModal', {open: true});
      this.getUserDeviceAuthAndList();
    },
    /**
     * window portal 에 이벤트를 추가한다.
     */
    setPortalEvent() {
      navigator.mediaDevices?.addEventListener('devicechange', this.getUserDeviceAuthAndList);
      window?.addEventListener('unload', this.handleUnload);
      window?.addEventListener('beforeunload', this.checkReallyClose);

      try {
        // this.windowRef?.addEventListener('beforeunload', this.checkDlgReallyClose);
        this.windowRef?.addEventListener('unload', this.closeMeeting);
        this.windowRef?.addEventListener('click', this.handelEvent);
        this.windowRef?.addEventListener('mousedown', this.handelEvent);
        this.windowRef?.addEventListener('mouseup', this.handelEvent);
        this.windowRef?.addEventListener('keyup', this.handelEvent);
        this.windowRef?.addEventListener('keydown', this.handelEvent);
        this.windowRef?.addEventListener('wheel', this.handelEvent);
        this.windowRef?.addEventListener('focus', this.handelFocus);
      } catch (e) {
        console.error('setPortalEvent', e)
      }
    },
    /**
     * window portal 의 이벤트를 제거한다.
     */
    removePortalEvent() {
      navigator.mediaDevices?.removeEventListener('devicechange', this.getUserDeviceAuthAndList);
      window?.removeEventListener('unload', this.handleUnload);
      window?.removeEventListener('beforeunload', this.checkReallyClose);

      try {
        // this.windowRef?.removeEventListener('beforeunload', this.checkDlgReallyClose);
        this.windowRef?.removeEventListener('unload', this.closeMeeting);
        this.windowRef?.removeEventListener('click', this.handelEvent);
        this.windowRef?.removeEventListener('mousedown', this.handelEvent);
        this.windowRef?.removeEventListener('mouseup', this.handelEvent);
        this.windowRef?.removeEventListener('keyup', this.handelEvent);
        this.windowRef?.removeEventListener('keydown', this.handelEvent);
        this.windowRef?.removeEventListener('wheel', this.handelEvent);
        this.windowRef?.removeEventListener('focus', this.handelFocus);
      } catch (e) {
        console.error('removePortalEvent', e)
      }
    },
    /**
     * PC 버전의 경우, 새로운 윈도우 창을 오픈하기 위해 윈도우를 만든다.
     */
    makeNewWindowPortal() {
      console.log('[makeNewWindowPortal] 새 창 열기 시도');
      
      // 팝업 차단 사전 검사
      try {
        const testPopup = window.open('', '', 'width=1,height=1');
        if (!testPopup || testPopup.closed || typeof testPopup.closed === 'undefined') {
          console.error('[makeNewWindowPortal] 팝업이 차단되어 있습니다.');
          this.$modal.show('common-alert-modal', {
            messageType: 'short',
            message: '팝업이 차단되었습니다. 브라우저 설정에서 팝업을 허용해주세요.'
          });
          return;
        }
        testPopup.close();
      } catch (e) {
        console.error('[makeNewWindowPortal] 팝업 테스트 중 오류:', e);
      }
      
      try {
        this.windowRef = window.open('', "", "width=1200, height=800,left=200,top=100");
        
        if (!this.windowRef) {
          console.error('[makeNewWindowPortal] window.open 실패 - 팝업 차단 또는 권한 문제');
          this.$modal.show('common-alert-modal', {
            messageType: 'short',
            message: '팝업이 차단되었습니다. 브라우저 설정에서 팝업을 허용해주세요.'
          });
          return;
        }
        
        // 팝업이 실제로 열렸는지 확인
        setTimeout(() => {
          if (this.windowRef.closed) {
            console.error('[makeNewWindowPortal] 팝업이 즉시 닫혔습니다 - 팝업 차단 가능성');
            this.$modal.show('common-alert-modal', {
              messageType: 'short',
              message: '팝업이 차단되었습니다. 브라우저 설정에서 팝업을 허용해주세요.'
            });
            return;
          }
        }, 100);
        
        console.log('[makeNewWindowPortal] 새 창 생성 성공:', this.windowRef);

        let title = this.windowRef.document.createElement('title');
        let meta = this.windowRef.document.createElement('meta');

        title.innerHTML = `${this.patientTotalInfo.patientInfo.patientInfoName}/${this.moment(this.selectedSchedule.scheduleExpectStartDatetime).locale(this.$t('country')).format('lll')}`;
        meta.name = "viewport";
        meta.content = "width=device-width, height=device-height, initial-scale=1.0, maximum-scale=1.0, minimum-scale=1.0, user-scalable=no";

        this.windowRef.document.getElementsByTagName('head')[0].appendChild(title);
        this.windowRef.document.getElementsByTagName('head')[0].appendChild(meta);

        this.windowRef.document.body.appendChild(this.$el);
        copyStyles(window.document, this.windowRef.document);
        
        console.log('[makeNewWindowPortal] 새 창 설정 완료');
      } catch (error) {
        console.error('[makeNewWindowPortal] 새 창 생성 중 오류:', error);
        this.$modal.show('common-alert-modal', {
          messageType: 'short',
          message: '새 창을 열 수 없습니다. 브라우저 설정을 확인해주세요.'
        });
      }
    },
    /**
     * portal 을 닫기 전 모든 값을 초기화 한다.
     */
    initAllValues(status = 'waiting') {
      console.dev('[initAllValues] 모든 값이 초기화 되었다.');
      this.$store.dispatch('toggleRemoteModal', {open: false, selectedSchedule: ''});

      // 통화와 관련된 값
      this.meeting = '';  // 서버로부터 받아온 미팅 정보
      this.attendeeId = '';
      this.audioVideo = ''; // 차임에서 만든 오디오 비디오 객체
      this.realTimeAttendees.clear(); // 실시간 참석자의 attendee id
      this.tileCount = 0; // 연결된 타일의 갯수,
      this.myTileId = 0;
      this.yourTileId = 0;
      this.stopCalling = true // 의사가 전화 중지 버튼을 클릭한 경우 true/ 아닌 경우 false
      this.startDatetime = ''; // 쌍방 통화 시작 날짜 시간
      this.progressTime = 0; //통화 시간(초)

      // 상태에 따른 화면에 메세지 노출 여부
      this.changeMeetingStatus(status);

      // 화면 엘레멘트 display on/off
      // this.yourAudioElement = false;

      // 버튼과 관련된 값
      this.arrow = true;
      this.mute = false;
      this.volume = true;
      this.switchVideo = true;

      // 모달내 환자 정보
      this.selectedSchedule = '';
      this.patientName = '';
      this.seqMedicalRelation = 0;
      this.patientTotalInfo = '';

      // 장치와 관련된 값
      this.deviceSetAlert = true;
      this.deviceSetModal = false;
      this.logger = {};
      this.deviceController = {};
      this.browserAlert = '';

      // 통화시간 카운트 메서드 종료
      this.stopCounting(this.countFunction);

      // 이벤트 해제
      this.removePortalEvent();
      // 모달 open/close 와 관련된 값
      this.windowRef = null;
      this.$store.dispatch('toggleRemoteModal', {open: false});
    },
    /**
     * 통화를 시작하기 위해 미팅 객체를 만들고, 세션을 만들고, 엘레멘트에 오디오비디오 객체를 바인딩해
     * 통화를 시작한다.
     * 이 함수가 진행되는 중간에 사용자가 종료 버튼을 누른다면, 메서드를 throw 시킨다.
     */
    makeACall() {
      console.dev('[makeACall] 1. 통화 요청을 시작합니다.');
      this.stopCalling = false;
      this.changeMeetingStatus('connecting');
      try {
        this.createMeetingAndAttendee().then(({meeting, attendee}) => {
          if (this.stopCalling) {
            throw new Error('');
          }
          return this.makeConfigurationAndSession(meeting, attendee);
        }).then((meetingSession) => {
          if (this.stopCalling) {
            throw new Error('');
          }
          return this.chooseDevice(meetingSession);
        }).then((result) => {
          this.audioVideo = result;
          if (this.stopCalling) {
            throw new Error('');
          }
          return this.bindElement(this.audioVideo);
        }).then((bindElement) => {
          if (this.stopCalling || !bindElement) {
            this.endTheCall();
            throw new Error('');
          }
          this.startCalling(bindElement);
        }).catch(() => {
          this.closeMeeting();
        });
      } catch (e) {
        console.log(e);
      }
    },
    /**
     * meeting,attendee 객체를 서버에 요청한다.
     */
    createMeetingAndAttendee() {
      console.dev('[createMeetingAndAttendee] 2. meeting/attendee 객체를 서버에 요청합니다.');

      const param = {seqSchedule: this.selectedSchedule.seqSchedule};
      return new Promise(((resolve, reject) => {
        _API.REMOTE.createMeetingFromServer(param)
            .then(({data}) => {
              let result = {meeting: false, attendee: false};
              const failedCode = data.failedCode;
              if (data.isSuccess) {
                this.meeting = data.Meeting;
                this.attendeeId = data.Attendee.AttendeeId;
                result = {
                  meeting: data.Meeting,
                  attendee: data.Attendee
                };
                resolve(result);
              } else {
                switch (failedCode) {
                    // 이미 완료 처리된 스케쥴 or 환자가 취소했거나 잘못된 스케쥴 or 삭제되거나 알수없는 스케쥴
                  case 'TE1104' :
                  case 'TE1106' :
                  case 'SE0120' :
                  case 'SE0000' :
                    this.windowRef.alert(`${this.$t('alert.already_completed_schedule')} ${this.$t('alert.try_call_after_create_schedule')}`);
                    break;
                  case 'TE1105' : // 이미 만료된 스케쥴
                    this.windowRef.alert(`${this.$t('alert.already_expired_schedule')} ${this.$t('alert.try_call_after_create_schedule')}`);
                    break;
                  case 'SE0121' : // 아직 상담 시간이 아님
                    this.windowRef.alert(`${this.$t('alert.can_start_before_15')}`);
                    break;
                  case 'PA0001' : // 앱을 사용하지 않아 수동등록 상태의 환자
                    this.windowRef.alert(this.$t('alert.not_member_app'));
                    break;
                    // 그 이외 백엔드 에러
                  case 'TE1101' :
                  case 'TE9999' :
                    this.windowRef.alert(`[error code: ${failedCode}] ${this.$t('alert.contact_rebless_manager')}`);
                    break;
                  default :
                    this.windowRef.alert(`${this.$t('alert.unexpected_error')} ${this.$t('alert.try_call_after_create_schedule')}`);
                    break;
                }

                this.changeMeetingStatus('stopping');
                this.stopCalling = true;
                resolve();
              }
            })
            .catch(e => {
              if (String(e).startsWith('401')) {
                this.windowRef.alert(`${this.$t('alert.unexpected_error')}`);
              } else {
                this.handleClose();
              }

              console.log('createMeetingFromServer', String(e).startsWith('401'), e);
              reject(`[createMeetingFromServer] ${e}`);
            });
      }));
    },
    /**
     * 미팅 세션과 콘피규레이션을 생성한다.
     * MeetingSessionConfiguration 에는 세션을 시작하는 데 필요한 정보가 포함
     */
    makeConfigurationAndSession(meeting, attendee) {
      console.dev('[makeConfigurationAndSession] 3. 콘피규와 섹션을 생성합니다.');
      return new Promise((resolve) => {
        try {
          const configuration = new MeetingSessionConfiguration(meeting, attendee);
          
          // DefaultStatsCollector getStats 오류 방지를 위한 설정
          console.log('[makeConfigurationAndSession] MeetingSessionConfiguration 생성 완료');
          
          const meetingSession = new DefaultMeetingSession(
            configuration, 
            this.logger, 
            this.deviceController
          );
          
          // audioVideo 객체에 오류 처리 추가
          if (meetingSession && meetingSession.audioVideo) {
            // getStats 오류를 방지하기 위한 래퍼 함수 추가
            const originalGetStats = meetingSession.audioVideo.getRTCPeerConnectionStats;
            if (originalGetStats) {
              meetingSession.audioVideo.getRTCPeerConnectionStats = function(selector) {
                try {
                  // selector가 MediaStreamTrack이 아닌 경우 null로 전달
                  if (selector && selector.kind === undefined) {
                    console.warn('[RemoteView] getStats: 잘못된 selector 파라미터, null로 대체');
                    return originalGetStats.call(this, null);
                  }
                  return originalGetStats.call(this, selector);
                } catch (error) {
                  console.warn('[RemoteView] getStats 오류 발생, 기본값 반환:', error);
                  return Promise.resolve(new Map());
                }
              }.bind(meetingSession.audioVideo);
            }
            
            console.log('[makeConfigurationAndSession] DefaultMeetingSession 생성 및 오류 처리 설정 완료');
          }
          
          resolve(meetingSession);
        } catch (error) {
          console.error('[makeConfigurationAndSession] 오류 발생:', error);
          // 기본 설정으로 재시도
          const configuration = new MeetingSessionConfiguration(meeting, attendee);
          const meetingSession = new DefaultMeetingSession(configuration, this.logger, this.deviceController);
          resolve(meetingSession);
        }
      });
    },
    /**
     * 오디오비디오 객체에 장치를 선택한다.
     */
    deviceDefaultVale() {
      return {
        videoInput: this.preSetDeviceId?.videoInputDeviceId ? this.preSetDeviceId.videoInputDeviceId : this.deviceList?.cameraList[0]?.deviceId || null,
        audioInput: this.preSetDeviceId?.audioInputDeviceId ? this.preSetDeviceId.audioInputDeviceId : this.deviceList?.micList[0]?.deviceId || null,
        audioOutput: this.preSetDeviceId?.audioOutputDeviceId ? this.preSetDeviceId.audioOutputDeviceId : this.deviceList?.speakerList[0]?.deviceId || null,
      }
    },
    async chooseDevice(meetingSession) {
      console.dev('[chooseDevice] 4. 디바이스를 오디오 객체에 넣습니다.');
      const chooseDeviceData = this.deviceDefaultVale();

      // device 가 한 개 이면서, default 인 경우, 탭에서 chooseVideoInputDevice 하지 못하는 버그가 있음.
      try {
        if (this.deviceList?.cameraList.length > 1 || (this.deviceList?.cameraList.length === 1 && chooseDeviceData.videoInput !== 'default'))
          await meetingSession.audioVideo.chooseVideoInputDevice(chooseDeviceData.videoInput)
              .catch(async () => {
                const deviceId = await this.checkDevice(chooseDeviceData.videoInput, meetingSession.audioVideo, this.deviceList?.cameraList);
                if (deviceId === false)
                  throw new Error('');
                else
                  await this.completeSetting({
                    ...this.preSetDeviceId,
                    videoInputDeviceId: deviceId,
                  });
              });

        if (this.deviceList?.micList.length > 1 || (this.deviceList?.micList.length === 1 && chooseDeviceData.audioInput !== 'default'))
          await meetingSession.audioVideo.chooseAudioInputDevice(chooseDeviceData.audioInput)

        if (this.deviceList?.speakerList.length > 1 || (this.deviceList?.speakerList.length === 1 && chooseDeviceData.audioOutput !== 'default'))
          await meetingSession.audioVideo.chooseAudioOutputDevice(chooseDeviceData.audioOutput)
      } catch (err) {
        this.stopCalling = true;
        this.windowRef.alert(this.$t('alert.check_device_available'));
        return ''
      }
      return meetingSession.audioVideo;
    },
    setMyTileId(audioVideo) {
      console.dev(`[videoTileDidUpdate] [로컬타일] 의사 타일 아이디 : ${this.myTileId}`);

      if (this.camera) {
        if (this.switchVideo) {
          this.$refs.myMonitor?.$refs.myVideo && audioVideo.bindVideoElement(this.myTileId, this.$refs.myMonitor?.$refs.myVideo);
        } else {
          this.$refs.monitor?.$refs.yourVideo && audioVideo.bindVideoElement(this.myTileId, this.$refs.monitor?.$refs.yourVideo);
        }
      } else {
        console.dev('[videoTileDidUpdate] [로컬타일] 카메라가 꺼져있으므로, 의사 화면을 바인딩하지 않습니다.');
      }
    },
    handleTileClick() {
      try {
        this.yourCameraLeftRight = !this.yourCameraLeftRight;
        this.yourElement.style.transform = this.yourElement.style.transform === '' ? 'rotateY(180deg)' : '';
      } catch (e) {

      }
    },
    handleTileMousemove(event) {
      // console.log('handleTileMousemove', event)
    },
    setYourTileId(audioVideo) {
      console.dev(`[videoTileDidUpdate] [Non-로컬타일] 환자 타일 아이디`);

      try {
        this.windowRef.document.getElementById('yourVideo').removeEventListener('click', this.handleTileClick)
      } catch (e) {

      }

      try {
        this.windowRef.document.getElementById('myVideo').removeEventListener('click', this.handleTileClick)
      } catch (e) {

      }

      if (this.camera) {
        try {
          if (this.switchVideo) {
            if (this.$refs.monitor?.$refs.yourVideo) {
              audioVideo.bindVideoElement(this.yourTileId, this.$refs.monitor?.$refs.yourVideo)

              if (this.windowRef.document.getElementById('yourVideo') !== null) {
                this.yourElement = this.windowRef.document.getElementById('yourVideo');
                this.windowRef.document.getElementById('yourVideo').style.transform = 'rotateY(180deg)';
                // this.windowRef.document.getElementById('yourVideo').title = '클릭시 좌우반전';
                this.windowRef.document.getElementById('yourVideo').addEventListener('click', this.handleTileClick)
                this.windowRef.document.getElementById('yourVideo').addEventListener('mousemove', this.handleTileMousemove)
              }
            }
          } else {
            if (this.$refs.myMonitor?.$refs.myVideo) {
              audioVideo.bindVideoElement(this.yourTileId, this.$refs.myMonitor?.$refs.myVideo)

              if (this.windowRef.document.getElementById('myVideo') !== null) {
                this.yourElement = this.windowRef.document.getElementById('myVideo');
                this.windowRef.document.getElementById('myVideo').style.transform = 'rotateY(180deg)';
                // this.windowRef.document.getElementById('myVideo').title = '클릭시 좌우반전';
                this.windowRef.document.getElementById('myVideo').addEventListener('click', this.handleTileClick)
                this.windowRef.document.getElementById('myVideo').addEventListener('mousemove', this.handleTileMousemove)
              }
            }
          }
        } catch (e) {

        }
      } else {
        this.$refs.monitor?.$refs.yourVideo && audioVideo.bindVideoElement(this.yourTileId, this.$refs.monitor?.$refs.yourVideo);
      }

      this.changeMeetingStatus('on');
    },
    observer(audioVideo) {
      return {
        videoTileDidUpdate: tileState => {
          console.dev('[bindElement] [videoTileDidUpdate] 타일상태가 업데이트 되었습니다. ', tileState);

          if (!tileState.boundAttendeeId || audioVideo.getAllVideoTiles().length <= 0) {
            console.dev('[bindElement] [videoTileDidUpdate] boundAttendeeId 바운드 된 attendeeId가 없기때문에 이 타일은 무시합니다. ');
            return;
          }

          this.tileCount = audioVideo.getAllVideoTiles().length;
          console.dev(`[bindElement] [videoTileDidUpdate] 타일의 갯수 : ${this.tileCount}`);

          if (tileState.localTile) {
            this.myTileId = tileState.tileId;
            this.setMyTileId(audioVideo);
          } else {
            this.yourTileId = tileState.tileId;
            this.setYourTileId(audioVideo);
          }
        },
        audioVideoDidStart: () => {
          console.dev('[audioVideoDidStart] 통화 세션 시작됩니다.');
          if (this.mute) {
            console.dev('[audioVideoDidStart] 뮤트 상태가', this.mute, '이므로 음소거합니다.');
            this.audioVideo.realtimeMuteLocalAudio();
          }

          this.realTimeAttendees.pushIfNotExist(this.attendeeId);
        },
        audioVideoDidStop: sessionStatus => {
          // session status 0 => Everything is OK so far.
          // session status 1 => 참석자는 정상적으로 회의에서 나갔습니다.
          // session status 6 => 환자가 먼저 나가고 30분이 지났을 경우/ 방폭파 / 회의가 종료되었습니다.
          // session status 19 => A task failed for an unknown reason.
          console.dev('[audioVideoDidStop] sessionStatus : ', sessionStatus.statusCode());
          const statusCode = sessionStatus.statusCode();

          if (statusCode === 6 && (this.progressTime > 0)) {
            this.completeSchedule();
          } else if (statusCode === 19) {
            // 공통적으로 비정상적인 이유로, 종료된 경우
            this.endTheCall('force');
          }
          this.meeting = '';
          this.audioVideo = '';
          this.yourTileId = 0;
          this.realTimeAttendees.clear();

          this.changeMeetingStatus(this.progressTime > 0 ? 'waiting' : 'stopping');

          setTimeout(() => {
            if (this.meetingEvents.length > 0) {
              fetch(this.API_ENDPOINT_URL, {
                method: 'POST',
                body: JSON.stringify(this.meetingEvents)
              });
              this.meetingEvents = [];
            } else {
              console.dev(`no meetingEvents found. length is ${this.meetingEvents.length}`);
            }
          }, 0);

        },
        audioVideoDidStartConnecting: reconnecting => {
          if (reconnecting) {
            console.dev('[audioVideoDidStartConnecting] 다시 연결을 시도합니다.');
            this.realTimeAttendees.removeItem(this.attendeeId);
            this.changeMeetingStatus('reconnecting');
          }
        },
        connectionDidBecomeGood: () => {
          console.dev('connectionDidBecomeGood', arguments)
        },
        connectionDidBecomePoor: () => {
          console.dev('connectionDidBecomePoor', arguments)
        },
        connectionDidSuggestStopVideo: () => {
          console.dev('connectionDidSuggestStopVideo', arguments)
        },
        connectionHealthDidChange: () => {
          console.dev('connectionHealthDidChange', arguments);
        },
        estimatedDownlinkBandwidthLessThanRequired: () => {
          console.dev('estimatedDownlinkBandwidthLessThanRequired', arguments)
        },
        metricsDidReceive: () => {
          console.dev('metricsDidReceive', arguments)
        },
        eventDidReceive: (name, attr) => {
          console.dev('eventDidReceive', arguments)
          const {meetingHistory, ...otherAttributes} = attr;
          switch (name) {
            case 'audioInputFailed':
            case 'videoInputFailed':
            case 'meetingStartFailed':
            case 'meetingFailed':
              this.meetingEvents.push({
                name,
                attributes: {
                  ...otherAttributes,
                  meetingHistory: meetingHistory.filter(({timestampMs}) => {
                    return Date.now() - timestampMs < 5 * 60 * 1000;
                  }),
                },
              });
              console.dev(`failed error 발생함. meetingEvents[${this.meetingEvents.length}]`)
              break;
            default:
              this.meetingEvents.push({
                name,
                attributes: otherAttributes,
              });
              console.dev(`[eventDidReceive] meetingEvents[${this.meetingEvents.length}]`)
              break;
          }
        },
        remoteVideoSourcesDidChange: () => {
          console.dev('remoteVideoSourcesDidChange', arguments)
        },
        videoAvailabilityDidChange: (availability) => {
          console.dev('videoAvailabilityDidChange 환자 카메라의 상태', availability.remoteVideoAvailable);
          // canStartLocalVideo: true
          // remoteVideoAvailable: false 환자가 카메라를 껐켰
          if (!availability.remoteVideoAvailable && this.realTimeAttendees.length === 2) {
            this.changeMeetingStatus('off');
          }
        },
        videoNotReceivingEnoughData: report => {
          console.dev('videoNotReceivingEnoughData', report);
          // attendeeId: "d0e24fb3-fd91-946d-eaff-6c71008fa5e1" // 비디오 데이터가 충분하지 않은 사용자의 ID를 반환
        },
        videoReceiveBandwidthDidChange: () => {
          console.dev('videoReceiveBandwidthDidChange');
        },
        videoSendDidBecomeUnavailable: () => {
          console.dev('videoSendDidBecomeUnavailable');
        },
        videoTileWasRemoved: () => {
          this.tileCount = audioVideo.getAllVideoTiles().length;
          this.switchVideo = true;
        }
      }
    },
    /**
     * 오디오비디오 객체를 엘레멘트에 바인딩하고, 관찰자를 이용해 상태를 관리한다.
     */
    async bindElement(audioVideo) {
      console.dev('[bindElement] 5. 오디오/비디오 객체를 엘레벤트에 바인딩합니다.');
      // 오디오 엘레멘트를 바인딩
      try {
        if (this.volume) {
          console.dev('[bindElement] 볼륨상태가 ', this.volume, ' 이기 때문에 오디오 객체를 바인딩합니다.');
          const yourAudio = document.getElementById('yourAudio')
          audioVideo.bindAudioElement(yourAudio);
        }

        audioVideo.addObserver(this.observer(audioVideo));

        // 실시간 참석자 상태
        const callback = (presentAttendeeId, present, _externalUserId, _dropped, _posInFrame) => {
          console.dev(presentAttendeeId === this.attendeeId ? '의사의 참석 상태 : ' + present : '환자의 참석 상태: ' + present + ' : ', presentAttendeeId);

          if (present) {
            this.realTimeAttendees.pushIfNotExist(presentAttendeeId);
          } else {
            this.realTimeAttendees.removeItem(presentAttendeeId);
            if (presentAttendeeId !== this.attendeeId) {
              console.dev('[realtimeSubscribeToAttendeeIdPresence] 환자가 방을 나갔습니다.');
              this.changeMeetingStatus('left');
              this.yourTileId = 0;
            }
          }
        };

        await audioVideo.realtimeSubscribeToAttendeeIdPresence(callback);
        await audioVideo.realtimeSubscribeToFatalError((error) => {
          console.dev('realtimeSubscribeToFatalError', error)
        })
      } catch (e) {
        console.dev('catch', '[realtimeSubscribeToAttendeeIdPresence]', e);
        return false;
      }
      return audioVideo;
    },
    /**
     * 엘레멘트에 오디오와 비디오를 시작 시킨다.
     */
    startCalling(bindElement) {
      console.dev('[startCalling] 6. 통화를 시작합니다.');

      bindElement.start();
      if (this.camera) {
        console.dev('[startCalling] 카메라가 켜져있을 경우, 로컬 타일을 시작합니다.');
        bindElement.startLocalVideoTile();
      }
    }, // ok
    /**
     * 통화시간 interval 메서드를 clear 한다.
     */
    stopCounting(func) {
      console.dev(`[stopCounting] ${func} 통화시간 카운팅을 종료합니다.`);
      clearInterval(func);
    }, // ok
    /**
     * 통화 상태를 변경한다.
     */
    changeMeetingStatus(status) {
      this.$store.dispatch('toggleRemoteModal', {status: status});
      this.meetingStatus = status;
    },
    /**
     * 사용자가 종료버튼을 클릭해, 화상통화를 종료한다.
     * endCase === force 인 경우, 강제 종료를 의미
     * 사용자에게 안내 팝업 후, 통화를 종료시킨다.
     * endCase === close 인 경우, 사용자가 창을 닫는 것을 의미
     * 모든 값을 초기화 하고, /appointments 화면을 리프레시 한다.
     * endCase === undefined 의 경우 통화 시간이 1초 이상이라면, 사용자에게 통화 종료 여부를 한번 더 확인하고
     * 통화를 종료 시킨다.
     */
    async endTheCall(endCase = undefined) {
      console.dev('[endTheCall] 종료 버튼을 클릭했습니다.');
      const endFunc = async () => {
        this.realTimeAttendees.clear(); // 참석자 0명으로 만들어
        this.changeMeetingStatus('stopping');

        if (this.audioVideo) {
          await this.audioVideo.chooseVideoInputDevice(null);
          await this.audioVideo.stop();
          this.audioVideo = '';
          (this.progressTime > 0) ? await this.completeSchedule() : await this.closeMeeting()
        }
      }

      if (endCase === 'force') {
        this.windowRef.alert(this.$t('RMC.end_call_due_to_connection'));
        await endFunc();
      } else {
        if (this.progressTime > 0) {
          await this.$modal.show('remote-yes-or-no-modal', {
            title: this.$t('RMC.sure_quit'), function: async () => {
              this.stopCalling = true; // 이 사람이 종료하고 싶다는 상태를 알리자
              await endFunc();
            }
          })
        } else {
          this.stopCalling = true; // 이 사람이 종료하고 싶다는 상태를 알리자
          await endFunc();
        }
      }
    },
    async closePortal() {
      console.dev('[closePortal] 창을 닫습니다.');

      this.changeMeetingStatus('stopping');
      this.stopCalling = true; // 이 사람이 종료하고 싶다는 상태를 알리자

      if (this.audioVideo) {
        await this.audioVideo.chooseVideoInputDevice(null);
        await this.audioVideo.stop();
        this.audioVideo = '';
        (this.progressTime > 0) ? await this.completeSchedule() : await this.closeMeeting()
      }

      this.handleClose();

      this.initAllValues();
      const path = this.$route.path;
      if (path === '/appointments' || path === '/' || path === '/remote') {
        this.$store.dispatch('refreshScheduleForToday', true);
      }
    },
    /**
     * 서버에 미팅 클로즈를 요청한다.
     */
    closeMeeting() {
      const param = {
        meetingId: this.meeting.MeetingId,
        seqSchedule: this.selectedSchedule.seqSchedule
      }

      return new Promise((resolve, reject) => {
        _API.REMOTE.closeMeetingFromServer(param)
            .then(({data}) => {
              if (data.isSuccess) { //failedCode is [EmptyString] when no error was found.
                console.dev('[closeMeeting] 서버에서 정상적으로 미팅이 클로즈되었습니다.');
                resolve(true);
              } else {
                console.dev(`[closeMeeting] 서버에서 심각한 에러로 미팅을 클로즈 시키지 못하였습니다. failedCode is ${data.failedCode}`);
                resolve(false);
              }
            })
            .catch(e => {
              if (String(e).startsWith('401')) {
                this.windowRef.alert(`${this.$t('alert.unexpected_error')}`);
              } else {
                this.handleClose();
              }

              reject(`[closeMeetingFromServer] ${e}`);
            })
            .finally(() => {
              console.dev('[closeMeeting] 창을 닫는다.');
              this.closePortal();
            });
      });
    },
    /**
     * 서버에 미팅 정보를 저장하고, 클로즈 시킨다.
     */
    completeSchedule() {
      const param = {
        seqSchedule: this.selectedSchedule.seqSchedule,
        startDatetime: this.startDatetime,
        progressTime: this.moment.utc(this.progressTime * 1000).format('HH:mm:ss'),
        meetingId: this.meeting.MeetingId
      };
      return new Promise((resolve, reject) => {
        _API.SCHEDULE.completeScheduleFromServer(param)
            .then(({data}) => {
              const failedCode = data.failedCode;
              if (data.isSuccess) {
                console.dev('[completeSchedule] 정상적으로 스케쥴이 저장이 되었습니다.');
                this.meeting = '';
                this.changeMeetingStatus('waiting');
                this.stopCalling = false;
                resolve(true);
              } else if (failedCode === 'SE0110' || failedCode === 'SE0111' || failedCode === 'SE0114') {
                console.dev('[completeSchedule] 비정상적인 결과, 다시 시도 바랍니다.');
                this.changeMeetingStatus('connecting');
                this.stopCalling = false;
                resolve(false);
              } else {
                this.changeMeetingStatus('connecting');
                this.stopCalling = false;
                resolve(false);
              }
            })
            .catch(e => {
              if (String(e).startsWith('401')) {
                this.windowRef.alert(`${this.$t('alert.unexpected_error')}`);
              } else {
                this.handleClose();
              }

              reject(`[closeMeetingFromServer] ${e}`);
            });
      });
    }, // ok
    checkReallyClose(event) {
      if (this.$store.getters.getVideoCallOpen) {
        if (document.getElementById('sessionError') === null && document.getElementById('errorDiv') === null) {
          this.checkClose = true;
          event.preventDefault();
          event.returnValue = '';
          return '';
        }
      }
    },
    // checkDlgReallyClose(event) {
    //   if (this.checkClose === false) {
    //     event.preventDefault();
    //     event.returnValue = '';
    //
    //     return '';
    //   }
    // },
    handelFocus() {
      this.checkClose = false;
    },
    // 버튼 조작 메서드
    clickArrowBtn(boolean) {
      this.arrow = boolean;
    },
    clickMicBtn() {
      this.mute = !this.mute;
    },
    clickVolumeBtn() {
      this.volume = !this.volume;
    },
    clickVideoBtn() {
      this.camera = !this.camera;
    },
    clickVideoSwitch() {
      this.switchVideo = !this.switchVideo;
    },
    /**
     * 사용자의 브라우저에 장치 사용권한을 묻는다.
     * 사용자가 장치 권한을 거부 시, 디바이스 세팅창과 헤더에 경고를 띄우는 역할
     */
    getUserDeviceAuthFromBrowser() {
      return new Promise(((resolve) => {
        navigator.mediaDevices
            ?.getUserMedia({audio: true, video: true})
            .then(() => {
              this.browserAlert = '';
              this.deviceSetAlert = false;
              resolve(true);
            })
            .catch((error) => {
              if (error.name === 'NotAllowedError') {
                this.browserAlert = this.$t('RMC.change_device_permission');
                this.deviceSetAlert = true;
                resolve(false);
              } else if (error.name === 'AbortError' || error.name === 'NotReadableError') {
                this.browserAlert = this.$t('RMC.device_used_another');
                this.deviceSetAlert = true;
                resolve(false);
              } else if (error.name === 'OverconstrainedError') {
                this.browserAlert = this.$t('RMC.hardware_error');
                this.deviceSetAlert = true;
                resolve(false);
              } else {
                this.browserAlert = this.$t('RMC.device_problem');
                this.deviceSetAlert = true;
                resolve(false);
              }
            });
      }));
    },
    /**
     * 장치를 호출하고, 셀렉트 박스에 넣는다.
     */
    async getUserDeviceList() {
      console.dev('[getUserDeviceList] 장치를 호출하고, 셀렉트 박스에 넣습니다.');

      try {
        // Amazon Chime SDK 비동기 로드
        console.log('[getUserDeviceList] Amazon Chime SDK 로드 시도');
        const sdkLoaded = await loadChimeSDK();
        
        if (!sdkLoaded) {
          console.warn('[getUserDeviceList] Amazon Chime SDK 로드 실패, Fallback 모드로 진행');
        }

        // LogLevel을 WARN으로 설정하여 통계 수집 관련 로그 최소화
        const logLevel = LogLevel?.WARN || LogLevel?.INFO || 'WARN';
        console.log('[getUserDeviceList] LogLevel 설정 (통계 수집 오류 최소화):', logLevel);
        
        this.logger = new ConsoleLogger('ChimeMeetingLogs', logLevel);
        this.deviceController = new DefaultDeviceController(this.logger, false);
        
        console.log('[getUserDeviceList] Logger/DeviceController 초기화 성공');
        
      } catch (error) {
        console.error('[getUserDeviceList] Logger/DeviceController 초기화 오류:', error);
        
        // 에러 발생 시 기본값으로 재시도
        try {
          console.log('[getUserDeviceList] Fallback 초기화 시도');
          this.logger = new ConsoleLogger('ChimeMeetingLogs', 'INFO');
          this.deviceController = new DefaultDeviceController(this.logger, false);
          console.log('[getUserDeviceList] Fallback 초기화 성공');
        } catch (fallbackError) {
          console.error('[getUserDeviceList] Fallback 초기화도 실패:', fallbackError);
          
          // 완전한 fallback으로 빈 디바이스 목록 반환
          this.deviceList = {
            cameraList: [],
            micList: [],
            speakerList: []
          };
          return this.deviceList;
        }
      }

      try {
        console.log('[getUserDeviceList] 디바이스 목록 조회 시작');
        
        // 비디오 디바이스 목록 조회
        const videoDevices = await this.deviceController.listVideoInputDevices();
        this.deviceList.cameraList = this.makeDeviceSelectBox(videoDevices);
        console.log('[getUserDeviceList] 비디오 디바이스 수:', videoDevices.length);

        // 오디오 입력 디바이스 목록 조회
        const audioInputDevices = await this.deviceController.listAudioInputDevices();
        this.deviceList.micList = this.makeDeviceSelectBox(audioInputDevices);
        console.log('[getUserDeviceList] 오디오 입력 디바이스 수:', audioInputDevices.length);
        
        // 오디오 출력 디바이스 목록 조회
        const audioOutputDevices = await this.deviceController.listAudioOutputDevices();
        this.deviceList.speakerList = this.makeDeviceSelectBox(audioOutputDevices);
        console.log('[getUserDeviceList] 오디오 출력 디바이스 수:', audioOutputDevices.length);
        
        console.log('[getUserDeviceList] 모든 디바이스 목록 조회 완료');
        
      } catch (error) {
        console.error('[getUserDeviceList] 디바이스 목록 조회 오류:', error);
        console.error('[getUserDeviceList] 오류 상세:', {
          message: error.message,
          stack: error.stack,
          name: error.name
        });
        
        // 에러 발생 시 빈 배열로 초기화
        this.deviceList = {
          cameraList: [],
          micList: [],
          speakerList: []
        };
      }
      
      return this.deviceList;
    },
    getUserDeviceAuthAndList() {
      this.getUserDeviceAuthFromBrowser();
      this.getUserDeviceList();
    },
    makeDeviceSelectBox(array) {
      const deviceList = array.reduce(function (acc, current) {// groupId 중복제거, 일부 장비에서 groupId 가 '' 인 경우 있어서 id를 조합
        if (acc.findIndex(({
                             groupId,
                             deviceId
                           }) => (groupId + deviceId) === (current.groupId + current.deviceId)) === -1) {
          acc.push(current);
        }
        return acc;
      }, []);
      deviceList.sort((a, b) => { // groupId 정렬, 되도록 같은 마이크끼리, 카메라끼리 연결되도록 하기 위함
        if (a.groupId < b.groupId)
          return -1;
        if (a.groupId > b.groupId)
          return 1;
        return 0;
      });
      const items = []
      for (let i = 0; i < deviceList.length; i++) {
        if (deviceList[i].label === "") {
          break;
        } // 브라우저 장치권한 설정이 차단이 경우 label 이 빈 스트링으로 나옴.
        const item = {};
        item["no"] = i + 1;
        item["key"] = i + 1;
        item["title"] = deviceList[i].label;
        item["deviceId"] = deviceList[i].deviceId;
        items.push(item);
      }
      return items;
    }, // ok
    /**
     * 사용가능한 디바이스를 호출하고, 세팅하는 창을 연다.
     * 오디오 비디오 객체를 생성하기 전이라면, 사용자의 브라우저에게 장치 사용 권한을 먼저 묻는다.
     */
    openSetModal() {
      if (!this.audioVideo) {
        this.getUserDeviceAuthFromBrowser();
      }
      this.getUserDeviceList();
      this.deviceSetModal = true;
    }, // ok
    closeSetModal() {
      this.deviceSetModal = false;
    }, // ok
    /**
     * 장치 id 를 로컬스토리지에 저장하고, 모달을 닫는다.
     * this.preSetDeviceId 는 watch 로 감시 중
     * @param deviceIdValues
     * @returns {Promise<void>}
     */
    async completeSetting(deviceIdValues) {
      this.preSetDeviceId = deviceIdValues;
      localStorage.setItem('preSetDeviceId', JSON.stringify(deviceIdValues));
      this.deviceSetModal = false;
    },
    // 환자 정보관련 메서드
    getSelectedScheduleFromVuex() {
      this.selectedSchedule = this.$store.getters.getVideoCallSelectedSchedule;
      this.seqMedicalRelation = this.selectedSchedule.seqMedicalRelation;
    }, // ok
    setPatientInfo() {
      const patientList = this.$store.state.patientList;
      for (let patient of patientList) {
        if (patient.patientInfo.seqMedicalRelation === this.seqMedicalRelation) {
          this.patientTotalInfo = patient;
        }
      }
    }, // ok
    resetDevLog() {
      this.devLog = [];
    },
    handleClose() {
      if (!this.deviceBrowser.notNewWindow) {
        this.windowRef?.close();
      } else {
        if (window.location.pathname.includes('remote'))
          this.$router.go(-1);
      }
    }
  }
}
</script>
<style lang="scss">
//html {
//  height: 100%;
//}

body {
  margin: 0;
  height: 100%;
}

.remote_section {
  display: flex;
  max-height: var(--app-height);
  overflow: hidden;
  width: 100%;
  height: 100%;
  min-width: 320px;


  @media screen and (max-width: 319px) {
    position: absolute;
  }

  position: fixed;

  .remote_container {
    &.left {
      width: 100%;
      //width: 60vw;
      position: relative;

      .remote_header {
        background: rgba(0, 0, 0, 0.6);
        position: absolute;
        width: 100%;
        height: 80px;
        color: rgb(255, 255, 255);
        z-index: 1;
        display: flex;
        align-items: center;
      }

      .remote_monitor_area {
        width: 100%;
        height: 100%;
        background: #000;
        display: flex;
        justify-content: center;
        align-items: center;
        text-align: center;

        .remote_monitor_spinner_container {
          position: unset;

          .loader {
            &.dots-wave {
              margin: 0;
            }
          }
        }
      }

      .patient_name {
        font-size: 1.5rem;
        font-weight: bold;
        margin: 0 0 0 20px;
        color: #fff;
        overflow: hidden;
        text-overflow: ellipsis;
        display: -webkit-box;
        -webkit-line-clamp: 2;
        -webkit-box-orient: vertical;
        word-wrap: break-word;
        white-space: pre-wrap;
        white-space: -moz-pre-wrap;
        white-space: -o-pre-wrap;
        word-break: break-word;
      }

      .remote_time {
        margin-left: 20px;
        margin-right: 180px;
        padding: 36px 0;
        font-size: 14px;
      }

      .remote_time span:nth-child(1) {
        color: #fff;
      }

      .remote_time span:nth-child(2) {
        color: #eae29c;
      }

      .remote_start_btn_box {
        position: absolute;
        right: 20px;
        top: 20px;
      }

      .remote_start_btn {
        display: flex;
        cursor: pointer;
        border-radius: 50px;
        background: #317cbb;
        padding: 10px 30px 10px;
        font-size: 15px;
        font-weight: bold;
        transition: background 0.5s;
        justify-content: center;
        align-items: center;
      }

      .remote_start_btn > div {
        margin-left: 10px;
        color: #fff;
        margin-top: 2px;
      }

      .remote_start_btn:hover {
        background: #2e73ad;
      }

      .remote_start_disabled {
        background: #bfbfbf;
      }

      .remote_start_disabled:hover {
        background: #bfbfbf;
        cursor: not-allowed;
      }

      .remote_end_btn {
        display: flex;
        cursor: pointer;
        border-radius: 50px;
        background: #bb4a31;
        padding: 10px 30px 10px;
        font-size: 15px;
        font-weight: bold;
        transition: background 0.5s;
        justify-content: center;
        align-items: center;
      }

      .remote_end_btn > div {
        margin-left: 10px;
        color: #fff;
        margin-top: 2px;
      }

      .remote_end_btn:hover {
        background: #d0482a;
      }

      .remote_my_monitor_area {
        position: absolute;
        bottom: 0;
        right: 0;
        border-top: 1px solid rgb(37, 37, 37);
        border-left: 1px solid rgb(37, 37, 37);
        background: rgb(21, 21, 21);
      }

      .remote_bottom_nav {
        position: absolute;
        bottom: 0;
        width: 263px;
        //width: 330px;
        height: 110px;
        left: 50%;
        transform: translate(-50%, 0);
        display: flex;
        justify-content: center;
        align-items: center;
        background: #333333;
        border-radius: 20px 20px 0 0;
        transition: bottom 0.7s;

        .btn_box {
          display: flex;
          flex-direction: column;
          justify-content: center;
          align-items: center;
        }
      }

      .remote_btn_mic {
        background: #fff;
        border-radius: 50px;
        height: 55px;
        width: 55px;
        margin: 10px;
        cursor: pointer;
        //transition: background 0.5s;
        display: flex;
        justify-content: center;
        align-items: center;
        box-shadow: 0 1px 3px rgba(0, 0, 0, 0.12), 0 1px 2px rgba(0, 0, 0, 0.24);
        transition: all 0.3s cubic-bezier(.25, .8, .25, 1);
      }

      .remote_btn_mic:hover {
        box-shadow: 0 14px 28px rgba(0, 0, 0, 0.25), 0 10px 10px rgba(0, 0, 0, 0.22);
      }

      .remote_btn_video {
        background: #fff;
        border-radius: 50px;
        height: 55px;
        width: 55px;
        margin: 10px;
        cursor: pointer;
        //transition: background 0.5s;
        display: flex;
        justify-content: center;
        align-items: center;
        box-shadow: 0 1px 3px rgba(0, 0, 0, 0.12), 0 1px 2px rgba(0, 0, 0, 0.24);
        transition: all 0.3s cubic-bezier(.25, .8, .25, 1);
      }

      .remote_btn_video:hover {
        box-shadow: 0 14px 28px rgba(0, 0, 0, 0.25), 0 10px 10px rgba(0, 0, 0, 0.22);
      }

      .remote_btn_volume {
        background: #fff;
        border-radius: 50px;
        height: 55px;
        width: 55px;
        margin: 10px;
        cursor: pointer;
        //transition: background 0.5s;
        display: flex;
        justify-content: center;
        align-items: center;
        box-shadow: 0 1px 3px rgba(0, 0, 0, 0.12), 0 1px 2px rgba(0, 0, 0, 0.24);
        transition: all 0.3s cubic-bezier(.25, .8, .25, 1);
      }

      .remote_btn_volume:hover {
        box-shadow: 0 14px 28px rgba(0, 0, 0, 0.25), 0 10px 10px rgba(0, 0, 0, 0.22);
      }

      .remote_btn_settings {
        margin-left: 20px;
        cursor: pointer;
      }

      .remote_btn_change {
        cursor: pointer;
        margin-left: 10px;
        margin-top: 10px;
        position: absolute;
        z-index: 1;
      }

      .remote_arrow_bottom {
        width: 50px;
        height: 20px;
        background: #333333;
        position: absolute;
        top: -20px;
        border-radius: 5px 5px 0 0;
        transition: background 0.5s ease 0s;
        display: flex;
        justify-content: center;
        align-items: center;
        cursor: pointer;
      }

      .remote_arrow_top {
        width: 50px;
        height: 20px;
        background: #333333;
        position: absolute;
        top: -20px;
        border-radius: 5px 5px 0 0;
        transition: background 0.5s ease 0s;
        display: flex;
        justify-content: center;
        align-items: center;
        cursor: pointer;
      }

      .hidden_remote_bottom_nav {
        bottom: -110px;
      }

      .remote_status_ment {
        font-size: 15px;
        color: #717171;
        font-weight: 700;
        display: block;
        text-align: center;
        margin-top: 20px;
      }

      .remote_video_off {
        display: flex;
        justify-content: center;
        align-items: center;
        min-width: 300px;
        min-height: 225px;
      }

      .remote_alert_balloon_01 {
        //position: relative;
        align-items: center;
        justify-content: center;
        display: flex;
        //color: red;
        color: white;
        position: absolute;
        top: 80px;
        left: 20px;
        background: #ffffff6b;
        padding: 8px 15px;
        border-radius: 10px;
      }

      .remote_alert_balloon_01:after {
        border-width: 0 10px 10px;
        border-style: solid;
        border-color: transparent transparent #ffffff6b;
        content: "";
        position: absolute;
        top: -10px;
        left: 12px;
      }

      .remote_set_balloon {
        //position: relative;
        align-items: center;
        justify-content: center;
        display: flex;
        color: red;
        position: absolute;
        top: 80px;
        left: 20px;
        background: #ffffff;
        padding: 30px 15px;
        border-radius: 10px;
        width: 300px;
        flex-direction: column;
        z-index: 1;

        .md_header {
          display: flex;
          width: 100%;
          justify-content: space-between;
        }

        .md_close {
          margin-right: 10px;
        }

        .set_modal_title {
          font-size: 17px;
          font-weight: 600;
          margin-bottom: 15px;
          margin-left: 6px;
          color: var(--blue70);
        }

        .table-container {
          display: unset;
          margin-bottom: 20px;

          .item-parent {
            flex-direction: column;
            align-items: unset;
            height: 70px;
          }
        }

        input {
          appearance: auto;
          height: 16px;
        }

        input[type="checkbox"] {
          display: unset;
          margin-right: 5px;
        }
      }

      .remote_set_balloon:after {
        border-width: 0 10px 10px;
        border-style: solid;
        border-color: transparent transparent #ffffff;
        content: "";
        position: absolute;
        top: -10px;
        left: 12px;
      }
    }

    &.right {
      width: 350px;
      height: 100%;
      transition: margin-right 0.5s ease 0s;
      z-index: 0;
      display: flex;
      background: #fff;

      &.hidden_remote_right {
        margin-right: -350px;
      }

      .arrow_box {
        display: flex;
        justify-content: center;
        align-items: center;
        height: var(--app-height);
        width: 20px;
        margin-left: -18px;

        .remote_note_arrow {
          cursor: pointer;
          background: #fff;
          height: 60px;
          display: flex;
          justify-content: center;
          align-items: center;
          border-radius: 5px 0 0 5px;
          width: 100%;
        }
      }

      .item_box {
        width: 100%;
        padding: 10px;
        display: block;
        min-width: 330px;
        overflow-y: auto;

        .title {
          color: #3d4857;
          text-align: left;
        }

        .table-container {
          grid-template-columns:none;
          grid-template-rows:none;
          display: block;

          .item-parent {
            margin: 5px;
          }
        }

        .item {
          width: 100%;
          padding: 5px 0 10px 0;
          border-bottom: 1px solid #ededed;

          &:nth-child(1) {
            height: 54px;
            display: table-cell;
            vertical-align: middle;

            &.patient_name {
              width: 100vw;
              color: #3d4857;
              font-size: 20px;
              font-weight: 600;
              text-align: left;
            }
          }

          &:nth-child(2) {
            .table-container {
              .item-parent {
                display: block;
                height: 30px;

                .item-title {
                  width: 160px;
                  height: 30px;
                  display: table-cell;
                  vertical-align: middle;
                }

                .item-value {
                  width: calc(100% - 165px);
                  height: 30px;
                  padding-left: 5px;
                  display: table-cell;
                  vertical-align: middle;
                }
              }
            }
          }

          &:nth-child(3) {
            .table-container {
              .item-parent {
                display: block;
                height: 20px;

                .item-title {
                  width: 160px;
                  height: 20px;
                  float: left;
                }

                .item-value {
                  width: calc(100% - 165px);
                  height: 20px;
                  padding-left: 5px;
                  float: left;
                }
              }
            }
          }

          &:nth-child(4) {
            border-bottom: none;

            .selectedSymptom_wrap {
              height: calc(100% - 20px - 54px - 161px - 212px - 60px - 50px);
              min-height: 130px;

              .table-container {
                height: unset;
                min-height: unset;

                .item-parent {
                  height: unset;

                  .item-value {
                    height: unset;
                  }
                }
              }
            }

            .table-container {
              height: calc(100% - 20px - 54px - 161px - 212px - 60px - 50px);
              min-height: 130px;

              .item-parent {
                height: 100%;

                .item-value {
                  height: 100%;

                  textarea {
                    height: 100%;
                  }
                }
              }
            }
          }

          &:nth-child(5) {
            border-bottom: none;
            padding-bottom: 5px;
          }
        }
      }
    }
  }

  @media screen and (min-width: 320px) and (max-width: 767px) {
    &.open {
      .remote_container {
        .remote_header {
          display: none !important;
        }

        &.left {
          width: 25px;
        }

        &.right {
          width: calc(100% - 25px);

          .item_box {
            min-width: unset !important;
          }
        }
        .remote_bottom_nav {
          display: none;
        }

        .hidden_remote_bottom_nav {
          display: none;
        }
      }
    }

    .remote_container {
      &.left {
        .remote_header {
          height: 60px;

          .remote_btn_settings {
            margin-left: 10px;
          }
        }

        .patient_name {
          display: none !important;
        }
      }

      &.right {
        width: 0;
      }

      .remote_start_btn_box {
        right: 10px !important;
        top: 10px !important;

        .remote_start_btn {
          padding-left: 10px;
          padding-right: 10px;
        }

        .remote_end_btn {
          padding-left: 10px;
          padding-right: 10px;
        }
      }

      .remote_start_btn > div {
        display: none;
      }

      .remote_end_btn > div {
        display: none;
      }

      .remote_bottom_nav {
        width: 160px !important;
        height: 55px !important;

        .btn_box {
          .remote_btn_mic, .remote_btn_video, .remote_btn_volume {
            width: 40px;
            height: 40px;
            margin: 5px !important;

            svg {
              width: 40px;
              height: 40px;
            }
          }

          .no-drag {
            display: none;
          }
        }
      }

      .hidden_remote_bottom_nav {
        bottom: -55px !important;
      }

      .remote_text > span {
        margin-left: 20px;
        margin-right: 20px;
      }

      .remote_my_monitor_area {
        .view {
          display: block !important;

          div {
            svg {
              background-color: #333333;
              border-radius: 50px;
              padding: 5px;
            }
          }
        }
      }

      .remote_set_balloon{
        top: 0 !important;
        left: 0 !important;
        z-index: 2 !important;
      }
    }
  }
}
</style>